// BigQuery — the only `database` category, and the only place `id` repeats.
//
// All four entries carry `id: 'bigquery_account'` in v3 (`utils/integrations.js:306-351`); they are
// four presentations of one workspace integration, told apart by `exportType`. That is exactly what
// `key` exists for, and it is what retires `getIntegrationInfo`'s `config.name === 'BigQuery
// Custom'` compare (`integrationStore.ts:216`): the store port (ORP-18697) reads
//
//     provider.id === 'bigquery_account' && !provider.exportType   → lists no accounts
//     provider.exportType                                          → filter accounts by `type`
//
// with no English display name anywhere in the branch.
//
// `connect: 'credential'` with a Google `authFamily` is not a contradiction — it is the
// service-account-JSON-vs-Google wizard contract §3 lists under Preserve.

import type { IntegrationProvider } from '../providers.types'

export const DATABASE_PROVIDERS: readonly IntegrationProvider[] = [
  {
    key: 'bigquery_custom',
    id: 'bigquery_account',
    nameKey: 'integrations.providers.bigQueryCustom',
    category: 'database',
    authFamily: 'google_email',
    connect: 'credential',
    labelFields: ['name'],
    logo: 'bigquery',
    // The only `bigquery_account` provider with no `exportType`, and the only one whose modal is a
    // wizard rather than a dataset picker (ORP-18702). The discriminator above is untouched.
    configComponent: () => import('../../components/connectors/BigQueryCustomConnector.vue'),
  },
  {
    key: 'bigquery_ga4',
    id: 'bigquery_account',
    nameKey: 'integrations.providers.bigQueryGa4',
    category: 'database',
    authFamily: 'google_email',
    connect: 'credential',
    labelFields: ['dataset_id'],
    exportType: 'ga4_export',
    logo: 'bigquery',
    additionalLogos: ['ga4'],
    configComponent: () => import('../../components/connectors/BigQueryChannelConnector.vue'),
  },
  {
    key: 'bigquery_adapty',
    id: 'bigquery_account',
    nameKey: 'integrations.providers.bigQueryAdapty',
    category: 'database',
    authFamily: 'google_email',
    connect: 'credential',
    labelFields: ['dataset_id'],
    exportType: 'adapty_export',
    logo: 'bigquery',
    additionalLogos: ['adapty'],
    configComponent: () => import('../../components/connectors/BigQueryChannelConnector.vue'),
  },
  {
    key: 'bigquery_play_store',
    id: 'bigquery_account',
    nameKey: 'integrations.providers.bigQueryPlayStore',
    category: 'database',
    authFamily: 'google_email',
    connect: 'credential',
    labelFields: ['dataset_id'],
    exportType: 'play_store_export',
    logo: 'bigquery',
    additionalLogos: ['play_store'],
    configComponent: () => import('../../components/connectors/BigQueryChannelConnector.vue'),
  },
]
